import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Une étiquette d'état — un MOT, pas une pastille.
 *
 * ADR-0024 : « aucune information portée par la couleur seule ». Le test tient
 * en une phrase : imprimée en noir et blanc, la page perd-elle de l'information ?
 * Ici, non — la couleur souligne ce que le texte dit déjà.
 */
export function Etiquette({
  children,
  ton = "neutre",
  className,
}: {
  children: ReactNode;
  ton?: "neutre" | "actif" | "succes" | "alerte";
  className?: string;
}) {
  const tons = {
    neutre: "bg-filet text-encre-douce",
    actif: "bg-chene-clair/50 text-encre",
    succes: "bg-succes/10 text-succes",
    alerte: "bg-alerte/10 text-alerte",
  } as const;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-[6px] px-2 py-1 text-xs font-medium whitespace-nowrap",
        tons[ton],
        className,
      )}
    >
      {children}
    </span>
  );
}

/** Une paire libellé / valeur, alignée avec ses voisines. */
export function Donnee({ libelle, children }: { libelle: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-0.5">
      <dt className="text-xs text-encre-douce">{libelle}</dt>
      <dd className="text-sm text-encre">{children}</dd>
    </div>
  );
}
